import React, { useEffect, useState } from "react";
import { fetchIpaSymbols, deleteIpaSymbol } from "./adminIpaService";
import AdminIpaSymbolForm from "./AdminIpaSymbolForm";

const AdminIpaSymbolPage = () => {
 const [data, setData] = useState([]);
 const [loading, setLoading] = useState(false);
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);
 const [showForm, setShowForm] = useState(false);
 const [editing, setEditing] = useState(null);
 const [search, setSearch] = useState("");

 useEffect(() => { loadData(); }, [page, search]);

 const loadData = async () => {
 setLoading(true);
 const res = await fetchIpaSymbols({ page, size: 20, search: search || undefined });
 if (res.status === 200 && res.data) {
 setData(res.data.content || []);
 setTotalPages(res.data.totalPages || 0);
 } else {
 setData([]);
 alert(res.message || "Failed to load symbols");
 }
 setLoading(false);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Delete this symbol?")) return;
 const res = await deleteIpaSymbol(id);
 if (res.status === 200 || res.status === 204) loadData();
 else alert(res.message);
 };

 const onFormSaved = () => { setShowForm(false); setEditing(null); loadData(); };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>IPA Symbols Management</h2>
 <button onClick={() => { setEditing(null); setShowForm(true); }}>+ Add Symbol</button>
 </div>

 {showForm && (
 <AdminIpaSymbolForm symbol={editing} onSaved={onFormSaved} onCancel={() => setShowForm(false)} />
 )}

 <input
 type="text"
 placeholder="Search symbols..."
 value={search}
 onChange={(e) => { setPage(0); setSearch(e.target.value); }}
 />

 {loading ? (
 <p>Loading...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th>Symbol</th>
 <th>Name</th>
 <th>Type</th>
 <th>Difficulty</th>
 <th>Example</th>
 <th>Order</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {data.length === 0 ? (
 <tr><td colSpan="7">No symbols found</td></tr>
 ) : (
 data.map((item) => (
 <tr key={item.id}>
 <td style={{ fontSize: "1.4rem" }}>{item.symbol}</td>
 <td>{item.name}</td>
 <td>{item.type}</td>
 <td>{item.difficulty}</td>
 <td>{item.exampleWord} {item.exampleIpa}</td>
 <td>{item.sortOrder}</td>
 <td>
 <button onClick={() => { setEditing(item); setShowForm(true); }}>Edit</button>
 <button className="delete-btn" onClick={() => handleDelete(item.id)}>Delete</button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 <div style={{ marginTop: "20px" }}>
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
 <span style={{ margin: "0 10px" }}>Page {page + 1} / {totalPages || 1}</span>
 <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
 </div>
 </div>
 );
};

export default AdminIpaSymbolPage;
